// src/components/admin/page-management/section-forms/TeamMemberForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TeamMemberForm = ({ content, updateContent }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch unique departments for the dropdown
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get('/api/team-members');
        // Extract unique departments
        const uniqueDepartments = [...new Set(response.data
          .filter(member => member.department) // Remove empty departments
          .map(member => member.department))];
        
        setDepartments(uniqueDepartments.sort());
        setLoading(false);
      } catch (err) {
        console.error('Error fetching departments:', err);
        setLoading(false);
      }
    };
    
    fetchDepartments();
  }, []);

  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Team Members Section</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Section Title</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="Our Team"
          value={content?.sectionTitle || ''}
          onChange={e => updateContent('sectionTitle', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.showDivider || false}
            onChange={e => updateContent('showDivider', e.target.checked)}
            className="mr-2"
          />
          <span>Show Title Divider</span>
        </label>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Layout</label>
        <select
            className="w-full p-2 border rounded"
            value={content?.layout || 'grid'}
            onChange={e => updateContent('layout', e.target.value)}
        >
            <option value="grid">Grid</option>
            <option value="list">List</option>
        </select>
        <p className="text-xs text-gray-500 mt-1">Grid shows members side by side, List stacks them vertically</p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Department Filter</label>
        <select
          className="w-full p-2 border rounded"
          value={content?.department || ''}
          onChange={e => updateContent('department', e.target.value)}
        >
          <option value="">All Departments</option>
          {departments.map(dept => (
            <option key={dept} value={dept}>{dept}</option>
          ))}
        </select>
      </div>
      
      <div className="mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.showLeadershipOnly || false}
            onChange={e => updateContent('showLeadershipOnly', e.target.checked)}
            className="mr-2"
          />
          <span>Show Leadership Team Only</span>
        </label>
      </div>
      
      <div className="mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.activeOnly !== false}
            onChange={e => updateContent('activeOnly', e.target.checked)}
            className="mr-2"
          />
          <span>Show Active Members Only</span>
        </label>
      </div>
      
      <div className="mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.showBio || false}
            onChange={e => updateContent('showBio', e.target.checked)}
            className="mr-2"
          />
          <span>Show Bio</span>
        </label>
      </div>
      
      <div className="mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.showSocialLinks || false}
            onChange={e => updateContent('showSocialLinks', e.target.checked)}
            className="mr-2"
          />
          <span>Show Social Links</span>
        </label>
      </div>
    </div>
  );
};

export default TeamMemberForm;